/* US store routing takes priority over the native country/language fallback. */
(function () {
  'use strict';

  if (window.__rmCountryLanguageLoaded) return;
  window.__rmCountryLanguageLoaded = true;

  let configNode = document.getElementById('rm-country-language-config');
  let form = document.getElementById('rm-country-language-form');
  let config = {};
  try {
    config = JSON.parse(configNode ? configNode.textContent || '{}' : '{}');
  } catch (error) {
    config = {};
  }

  let available = Array.isArray(config.availableLocales)
    ? config.availableLocales.filter(function (locale) { return typeof locale === 'string'; })
    : [];
  const manualKey = 'rm_manual_locale';
  const guardPrefix = 'rm_country_language:';
  const guardLifetime = 30000;
  const usRouting = config.usRouting || {};
  const usRoutingReady = routeUSVisitor();
  window.__rmUSRoutingReady = usRoutingReady;

  function relativeStorePath() {
    const root = String(usRouting.root || '/').replace(/\/$/, '');
    const path = window.location.pathname;
    return root && (path === root || path.indexOf(root + '/') === 0) ? path.slice(root.length) || '/' : path;
  }

  function canRouteUSVisitor() {
    if (!config.enabled || !usRouting.enabled) return false;
    if (!['retromuscle.net', 'www.retromuscle.net'].includes(window.location.hostname)) return false;
    if (window.Shopify && window.Shopify.designMode) return false;
    if (window.self !== window.top) return false;
    const params = new URLSearchParams(window.location.search);
    if (['preview_theme_id', 'preview_key', 'preview_script_id', 'section_id', 'sections', '_fd'].some(function (name) { return params.has(name); })) return false;
    if (/googlebot|bingbot|applebot|duckduckbot|yandexbot|baiduspider|facebookexternalhit|twitterbot/i.test(navigator.userAgent || '')) return false;
    // Existing accounts, app portals and survey links belong to the original store.
    return !/^\/(?:account|orders|checkouts?|apps|password|challenge|products_preview)(?:\/|$)/.test(relativeStorePath()) &&
      !/^\/pages\/(?:post-purchase-survey|affiliate[^/]*)(?:\/|$)/.test(relativeStorePath());
  }

  async function fetchRoutingJSON(url) {
    const controller = new AbortController();
    const timer = window.setTimeout(function () { controller.abort(); }, 2500);
    try {
      const response = await window.fetch(url, {credentials: 'same-origin', signal: controller.signal});
      if (!response.ok) throw new Error('Routing request failed');
      return await response.json();
    } finally {
      window.clearTimeout(timer);
    }
  }

  async function detectedCountry() {
    const key = 'rm_geo_country_v1';
    try {
      const cached = JSON.parse(window.sessionStorage.getItem(key) || 'null');
      if (cached && /^[A-Z]{2}$/.test(cached.country) && Date.now() - cached.time < 300000 && cached.time <= Date.now()) return cached.country;
    } catch (error) {
      // Detection still works without browser storage.
    }
    const endpoint = new URL(String(usRouting.root || '/').replace(/\/?$/, '/') + 'browsing_context_suggestions.json', window.location.origin);
    if (endpoint.origin !== window.location.origin) return '';
    endpoint.searchParams.set('country[enabled]', 'true');
    endpoint.searchParams.set('language[enabled]', 'false');
    const result = await fetchRoutingJSON(endpoint.href);
    const country = result && result.detected_values && result.detected_values.country && result.detected_values.country.handle;
    if (typeof country !== 'string' || !/^[A-Z]{2}$/.test(country)) return '';
    try {
      window.sessionStorage.setItem(key, JSON.stringify({country: country, time: Date.now()}));
    } catch (error) {
      // Routing does not depend on storage being available.
    }
    return country;
  }

  function destinationURL(destinations) {
    const types = {product: 'products', collection: 'collections', page: 'pages', blog: 'blogs', article: 'articles'};
    const group = destinations[types[usRouting.pageType]] || {};
    const resource = group[String(usRouting.resourceId)] || {};
    const sourceParams = new URLSearchParams(window.location.search);
    let path = resource.path || '/';
    const currentPath = relativeStorePath();
    if (usRouting.pageType === 'cart') path = '/cart';
    if (usRouting.pageType === 'search') path = '/search';
    if (/^\/policies\/(privacy-policy|refund-policy|shipping-policy|terms-of-service|contact-information|legal-notice)\/?$/.test(currentPath)) path = currentPath;
    if (typeof path !== 'string' || !path.startsWith('/') || path.startsWith('//')) path = '/';
    const destination = new URL(path, 'https://retromuscle.us');
    if (destination.origin !== 'https://retromuscle.us') return new URL('https://retromuscle.us/');
    // Never copy customer tokens, email addresses, preview flags or .net variant IDs.
    const marketingKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id', 'fbclid', 'gclid', 'gbraid', 'wbraid', 'msclkid', 'ttclid'];
    for (const key of marketingKeys) {
      if (sourceParams.has(key)) destination.searchParams.set(key, sourceParams.get(key));
    }
    const variant = sourceParams.get('variant');
    if (resource.variants && Object.prototype.hasOwnProperty.call(resource.variants, variant)) destination.searchParams.set('variant', resource.variants[variant]);
    if (usRouting.pageType === 'search' && sourceParams.has('q')) destination.searchParams.set('q', sourceParams.get('q'));
    if (resource.path && /^#[A-Za-z][A-Za-z0-9_-]{0,80}$/.test(window.location.hash)) destination.hash = window.location.hash;
    return destination;
  }

  async function routeUSVisitor() {
    if (!canRouteUSVisitor()) return false;
    let country = config.country;
    if (country !== 'US') {
      try {
        country = await detectedCountry();
      } catch (error) {
        return false;
      }
    }
    if (country !== 'US') return false;
    let destinations = {};
    try {
      destinations = await fetchRoutingJSON(usRouting.destinationsUrl);
      if (!destinations || destinations.version !== 1) destinations = {};
    } catch (error) {
      // The US home page remains a valid fallback if the mapping cannot load.
    }
    const target = destinationURL(destinations);
    window.__rmUSRoutingTarget = target.href;
    window.location.replace(target.href);
    return true;
  }

  function isAvailable(locale) {
    return available.indexOf(locale) !== -1;
  }

  function readCookie(name) {
    let prefix = name + '=';
    try {
      return document.cookie.split(';').reduce(function (value, part) {
      let item = part.trim();
      if (item.indexOf(prefix) !== 0) return value;
      try {
        return decodeURIComponent(item.slice(prefix.length));
      } catch (error) {
        return value;
      }
      }, '');
    } catch (error) {
      return '';
    }
  }

  function writeCookie(name, value) {
    try {
      document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=31536000; samesite=lax';
    } catch (error) {
      // Cookie access can be disabled; manual selection still remains in memory.
    }
  }

  function readManualLocale() {
    try {
      let local = window.localStorage.getItem(manualKey);
      if (local) return local;
    } catch (error) {
      // Fall back to the first-party cookie below.
    }
    return readCookie(manualKey);
  }

  function persistManualLocale(locale) {
    if (!isAvailable(locale)) return;
    try {
      window.localStorage.setItem(manualKey, locale);
      return;
    } catch (error) {
      // A cookie is still useful when storage is disabled.
    }
    writeCookie(manualKey, locale);
  }

  function isLoopGuardAvailable() {
    try {
      let probe = '__rm_country_language_probe__';
      window.sessionStorage.setItem(probe, '1');
      window.sessionStorage.removeItem(probe);
      return true;
    } catch (error) {
      return false;
    }
  }

  function wasRedirectedRecently(country, locale) {
    if (!isLoopGuardAvailable()) return true;
    let key = guardPrefix + String(country || '') + ':' + locale;
    let now = Date.now();
    try {
      let previous = Number(window.sessionStorage.getItem(key) || 0);
      if (previous && now - previous < guardLifetime) return true;
      window.sessionStorage.setItem(key, String(now));
      return false;
    } catch (error) {
      return true;
    }
  }

  function setManualFromEvent(event) {
    let target = event.target;
    if (!target || !target.closest) return;
    let control = target.closest('button[lang], select[name="locale_code"], input[name="locale_code"]:not([type="hidden"])');
    if (!control) return;
    let localizationForm = control.closest('.shopify-localization-form');
    if (!localizationForm || localizationForm.id === 'rm-country-language-form') return;
    let locale = control.getAttribute('lang') || control.value;
    if (locale && isAvailable(locale)) persistManualLocale(locale);
  }

  document.addEventListener('click', setManualFromEvent, true);
  document.addEventListener('change', setManualFromEvent, true);

  async function redirectWhenReady() {
    if (await usRoutingReady) return;
    if (['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname)) return;
    if (!config.enabled || !form || !isAvailable(config.targetLocale)) return;
    let manualLocale = readManualLocale();
    let desiredLocale = isAvailable(manualLocale) ? manualLocale : config.targetLocale;
    if (!desiredLocale || desiredLocale === config.currentLocale) return;
    if (wasRedirectedRecently(config.country, desiredLocale)) return;

    let localeInput = form.querySelector('[name="locale_code"]');
    let returnInput = form.querySelector('[name="return_to"]');
    if (!localeInput || !returnInput) return;
    localeInput.value = desiredLocale;
    returnInput.value = window.location.pathname + window.location.search + window.location.hash;
    form.submit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', redirectWhenReady, { once: true });
  } else {
    redirectWhenReady();
  }
}());
